<template>
  <div class="AdminClient">
    <AdminClientsHeader @onSearchClientGroups="onSearchClientGroups" />
    <transition name="fade">
      <AdminClientsTable v-if="!isLoading" ref="clientTable" />
    </transition>
  </div>
</template>

<script>
import AdminClientsHeader from "@/views/admin/AdminClientsHeader.module.vue";
import AdminClientsTable from "@/views/admin/AdminClientsTable.module.vue";

export default {
  components: {
    AdminClientsHeader,
    AdminClientsTable,
  },
  data () {
    return {
      isLoading: false,
    };
  },
  methods: {
    /**
     * @param {object} options
     */
    async onSearchClientGroups (options) {
      await this.$refs.clientTable.initClients(options);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/variables.scss";

.AdminClient {
  width: 99%;
  margin-left: 0.7rem;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
